// extracted by mini-css-extract-plugin
export default {"tabsSection":"settingsNav_tabsSection__rfTS7","tabs":"settingsNav_tabs__80fnS","tab":"settingsNav_tab__bkPPz","tabActive":"settingsNav_tabActive__Ze4nt"};